import styled from 'styled-components';

const FormFooter = styled.div `
  text-align: center;
`;

export { FormFooter };
